import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Exemption } from '../models/exemption.model';
import { ApiResponse } from '../models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class ExemptionService {
  private apiUrl = `${environment.apiUrl}/exemptions`;

  constructor(private http: HttpClient) {}

  /**
   * Get exemption by enrollment ID
   */
  getExemptionByEnrollment(enrollmentId: number): Observable<ApiResponse<Exemption>> {
    return this.http.get<ApiResponse<Exemption>>(`${this.apiUrl}/enrollment/${enrollmentId}`);
  }

  /**
   * Get exemption by ID
   */
  getExemptionById(id: number): Observable<ApiResponse<Exemption>> {
    return this.http.get<ApiResponse<Exemption>>(`${this.apiUrl}/${id}`);
  }

  /**
   * Create exemption request
   */
  createExemption(data: FormData): Observable<ApiResponse<Exemption>> {
    return this.http.post<ApiResponse<Exemption>>(this.apiUrl, data);
  }

  /**
   * Update exemption
   */
  updateExemption(id: number, data: FormData): Observable<ApiResponse<Exemption>> {
    return this.http.put<ApiResponse<Exemption>>(`${this.apiUrl}/${id}`, data);
  }

  /**
   * Upload exemption document
   */
  uploadDocument(exemptionId: number, document: FormData): Observable<ApiResponse<any>> {
    return this.http.post<ApiResponse<any>>(`${this.apiUrl}/${exemptionId}/documents`, document);
  }

  /**
   * Delete exemption document
   */
  deleteDocument(exemptionId: number, documentId: number): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.apiUrl}/${exemptionId}/documents/${documentId}`);
  }

  /**
   * Get exemption status
   */
  getExemptionStatus(exemptionId: number): Observable<ApiResponse<Exemption>> {
    return this.http.get<ApiResponse<Exemption>>(`${this.apiUrl}/${exemptionId}/status`);
  }
}
